module.exports = __webpack_public_path__ + "img/172.5a5e404e.jpg";